module.exports = __webpack_public_path__ + "assets/img/path22.3786f169.png";